export const bytesToMB = (bytes: number) => {
  return Math.round((bytes / (1024 * 1024)) * 100) / 100;
};

export const gbToMB = (gb: number) => {
  return Math.round(gb * 1024 * 100) / 100;
};
